import { isPresent } from './isPresent';
import { unique } from './unique';

type WithProdukteBuchungsnummern = { produkte: { buchungsnummer: string }[] };

export const getBuchungsnummern = ({ produkte }: WithProdukteBuchungsnummern): string[] =>
  produkte.map(({ buchungsnummer }) => buchungsnummer).filter(unique);

export const formatBuchungsnummern = (thema: WithProdukteBuchungsnummern): string =>
  getBuchungsnummern(thema).join(', ');

export const getProduktManager = ({ produkte }: { produkte: { produktManager: string | null }[] }): string[] =>
  produkte
    .map(({ produktManager }) => produktManager)
    .filter(isPresent)
    .filter(unique);

export const getProduktManagerAssistenz = ({
  produkte,
}: {
  produkte: { produktManagerAssistenz: string | null }[];
}): string[] =>
  produkte
    .map(({ produktManagerAssistenz }) => produktManagerAssistenz)
    .filter(isPresent)
    .filter(unique);
